import { render } from "./ShopSheetComponent.vue?vue&type=template&id=32081299"
import script from "./ShopSheetComponent.vue?vue&type=script&lang=js"
export * from "./ShopSheetComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__